// pages/Dashboard.jsx
import FAQPage from "../../components/home/policyComponents/FAQPage";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <FAQPage />
    </HomeLayout>
  );
}
